/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled from 'styled-components';
import { typography, colors } from '@everlywell/leaves';
import { fonts } from 'styles/ariesTheme';

const TextAccent = styled.div`
  margin: 12px 0;
  font-family: ${typography.type.nexa};
  font-size: 14px;
  font-weight: ${typography.weight.bold};
  line-height: 1.57;
  color: ${colors.teal6};
`;

const CardImage = styled.div.attrs(props => ({
  backgroundImageUrl: props.backgroundImageUrl,
}))`
  width: 100%;
  height: 68px;
  padding: 0 60px 0 72px;
  background-color: #d8d8d8;
  border-radius: 4px 4px 0 0;
  ${props =>
    props.backgroundImageUrl &&
    `
        background-image: url(${props.backgroundImageUrl});
        background-size: cover;
        background-repeat: no-repeat;
    `}
`;

const UpsellContainer = styled.div`
  margin: 12px 0 0;
  padding: 0 0 12px;
  border-radius: 4px;
  box-shadow: 0 7px 25px -3px rgba(189, 196, 197, 0.45),
    0 5px 10px -1px rgba(181, 194, 195, 0.15);
  background-color: ${colors.white};
`;

const ButtonCostContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 21px;
`;

const CardTitle = styled.div`
  margin: 12px 0 0 21px;
  font-family: ${typography.type.nexa};
  font-size: 14px;
  font-weight: ${typography.weight.bold};
  line-height: 1.86;
  letter-spacing: 0.21px;
  color: ${colors.gray5};
`;

const CardDescription = styled.div`
  margin: 0 0 13px 21px;
  font-family: ${typography.type.nexa};
  font-weight: ${typography.weight.book};
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.gray4};
`;

const UpgradeCost = styled.span`
  font-family: ${typography.type.nexa};
  font-size: 16px;
  line-height: 2;
  text-align: right;
  color: ${colors.gray4};
`;

export {
  TextAccent,
  CardImage,
  ButtonCostContainer,
  UpsellContainer,
  CardTitle,
  CardDescription,
  UpgradeCost,
};
